exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_profiles_32ZGdfdyD9lzKgnpFkqFBB {\n  width: 100%;\n}\n\n.IA_profiles_32ZGdfdyD9lzKgnpFkqFBB h1 {\n  float: left;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_profiles": "IA_profiles_32ZGdfdyD9lzKgnpFkqFBB"
};